module.exports = __webpack_public_path__ + "img/互动贴纸--多种款式--张嘴后gif.607aec8b.gif";